import { render } from "./LegacyProjectBanner.vue?vue&type=template&id=ef8003f0"
import script from "./LegacyProjectBanner.vue?vue&type=script&lang=js"
export * from "./LegacyProjectBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__